import { SelectionModel } from '@angular/cdk/collections';
import { AfterContentInit, AfterViewInit, Component, ContentChildren, EventEmitter, Input, OnChanges, Output, QueryList, SimpleChanges, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatColumnDef, MatTable, MatTableDataSource } from '@angular/material/table';

@Component({
	selector: 'app-selectable-table',
	templateUrl: './selectable-table.component.html'
})
export class SelectableTableComponent<T> implements AfterContentInit, AfterViewInit, OnChanges {
	@Input() dataSource!: MatTableDataSource<T>;
	@Input() displayColumns: string[] = [];
	@Input() showPaginator = true;
	@Input() selection = new SelectionModel<T>(true, []);
	@Output() selectionChange = new EventEmitter<T[]>();

	@ContentChildren(MatColumnDef) private columnDefinitions!: QueryList<MatColumnDef>;
	@ViewChild(MatTable, { static: true }) private table!: MatTable<T>;
	@ViewChild(MatPaginator) private paginator?: MatPaginator;

	get columns(): string[] {
		return ['select', ...this.displayColumns.filter(column => column !== 'select')];
	}

	ngAfterContentInit(): void {
		this.columnDefinitions.forEach(column => this.table.addColumnDef(column));
	}

	ngAfterViewInit(): void {
		this.updatePaginator();
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes['dataSource'] || changes['showPaginator']) {
			this.updatePaginator();
		}
	}

	isAllSelected(): boolean {
		return this.dataSource.filteredData.length > 0 &&
			this.dataSource.filteredData.every(row => this.selection.isSelected(row));
	}

	toggleAllRows(): void {
		if (this.isAllSelected()) {
			this.selection.deselect(...this.dataSource.filteredData);
		} else {
			this.selection.select(...this.dataSource.filteredData);
		}
		this.emitSelection();
	}

	toggleRow(row: T): void {
		this.selection.toggle(row);
		this.emitSelection();
	}

	checkboxLabel(row?: T): string {
		if (!row) {
			return `${this.isAllSelected() ? 'Deseleccionar' : 'Seleccionar'} todo`;
		}
		return `${this.selection.isSelected(row) ? 'Deseleccionar' : 'Seleccionar'} fila ${this.dataSource.data.indexOf(row) + 1}`;
	}

	private emitSelection(): void {
		this.selectionChange.emit(this.selection.selected);
	}

	private updatePaginator(): void {
		if (this.paginator && this.dataSource) {
			this.dataSource.paginator = this.paginator;
		}
	}
}